import { HistoryModel } from '@leverege/molten/data-viewers';
import { Config } from '@leverege/plugin';
const TYPE = Config.get('modelTypes', 'caseHistoryModel', 'recovr.mapRenderer.case.HistoryModel');
function create(...rest) {
  return {
    ...HistoryModel.create(...rest),
    type: TYPE
  };
}
function update(model) {
  if (model.type !== TYPE) {
    return {
      ...model,
      type: TYPE
    };
  }
  return model;
}
export default {
  ...HistoryModel,
  create,
  update,
  TYPE
};